import Dialog from "~/ui/dialog";
import { node } from "~/util/dom";
import { store } from "~/state/store";
import { setCoordinates } from "~/state/map/state";
import { CONFIG } from "./config";
import { getMobileOperatingSystem } from "~/util/userweb";
import { ILandingPromoURL, LANDING_PROMO_URLS } from "~common/constants/landing-page-promo";

interface ILoadingPagePromoOptions extends ILandingPromoURL {
	action?: (query?: string) => void;
	respo?: ILandingPromoURL["respo"] & {
		action?: (query?: string) => void;
	};
	mobilApp?: ILandingPromoURL["mobilApp"] & {
		action?: (query?: string) => void;
	}
}

const SEARCH_ZOOM = 12;

function log(name = "", data: any) {
	Mapy.getComponent("logger").log(name, {
		name: "Pomáháme hodnocení",
		...data,
	});
}

function realnaRecenceCB(query: string) {
	// analytika
	log("promo", {
		type: "popup_reviews_evaluate_firms",
	});

	const geoCoords = Mapy.getGEOLocationCoords();
	const { longitude, latitude } = store.getState().map;

	store.dispatch(setCoordinates({
		longitude: geoCoords ? geoCoords.x : longitude,
		latitude: geoCoords ? geoCoords.y : latitude,
		zoom: SEARCH_ZOOM,
		animate: false,
	}));

	Mapy.getComponent("search").activate().setState({
		q: query,
		cat: 1,
		sf: "review:from40",
		searchOrigin: "promo",
	});
	Mapy.getComponent("history").save();
}

const SETTINGS: Array<ILoadingPagePromoOptions> = [
	{
		...LANDING_PROMO_URLS[0],
		action: realnaRecenceCB,
	},
	{
		...LANDING_PROMO_URLS[1],
		action: realnaRecenceCB,
	},
	{
		...LANDING_PROMO_URLS[2],
		action: () => {
			Mapy.getComponent("route").activate();
		},
		respo: {
			...LANDING_PROMO_URLS[2].respo,
			action: () => {
				const os = getMobileOperatingSystem();
				let url = "https://play.google.com/store/apps/details?id=cz.seznam.mapy&listing=public_transport_train_bus_timetables";

				if (os === "i") {
					url = "https://apps.apple.com/us/app/mapy-com-bike-hiking-trails/id411411020?ppid=87cc0182-0d35-43ae-801c-aeb230c09181";
				}

				window.open(url);
			},
		},
	},
];

export default class LandingPagePromo {
	_active: boolean;

	_url: string;

	_dialog: Dialog;

	_options: ILoadingPagePromoOptions;

	constructor() {
		this._options = null;
		this._dialog = null;
		this._active = false;
		this._url = "";
	}

	static destroy() {
	}

	isActive() {
		return this._active;
	}

	activate() {
		if (this.isActive()) {
			return this;
		}

		this._url = location.pathname + location.search;

		if (!Mapy.getComponent("history").isFromHistory()) {
			history.pushState(null, "", `/${this._options.url}`);
		}

		this._active = true;
		this._open();

		return this;
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		this._active = false;
		this._close();

		if (this._url.indexOf(this._options.url) === -1) {
			history.replaceState(null, "", this._url);
		} else {
			Mapy.getComponent("history").save(true);
		}

		return this;
	}

	setState() {
		// tady zjistime, jestli neco z toho pouzijeme nebo ne a podle toho zapiseme do this._options
		const index = SETTINGS.findIndex(item => location.pathname.indexOf(item.url) > -1);

		if (index > -1) {
			const setting = SETTINGS[index];

			this._options = {
				...setting,
				...setting.respo && Mapy.Util.isSmallResolution() ? setting.respo : {} as ILoadingPagePromoOptions["respo"],
				...setting.mobilApp && CONFIG.isMapyczApp ? setting.mobilApp : {} as ILoadingPagePromoOptions["mobilApp"],
			};

			this.activate();
		} else {
			this.deactivate();
		}
	}

	static getState() {
		return {};
	}

	_open() {
		const trans = this._options.trans["en" in this._options.trans && ["cs", "sk"].indexOf(CONFIG.defaultLang) === -1 ? "en" : "cs"];

		this._dialog = new Dialog({
			className: `firm-promo${CONFIG.isMapyczApp ? " isMApyApp" : ""}`,
			title: trans.title,
			onClose: () => {
				// analytika
				log("promo", {
					type: "popup_reviews_close",
				});

				this.deactivate();
			},
		});
		this._dialog.addBtn({
			title: trans.reviewBtn,
			logIgnore: true,
			type: "ok",
			cb: () => {
				this.deactivate();
				this._options.action(this._options.url);
			},
		});
		const img = node("img", { src: `/img/promo-popup/${this._options.img}.png`, srcset: `/img/promo-popup/${this._options.img}@2x.png 2x` });
		const description = node("p", { className: "description", textContent: trans.description });

		this._dialog.dom.content.appendChild(description);
		this._dialog.dom.content.appendChild(img);
		this._dialog.open();
		document.body.style.overflow = "hidden";

		// analytika
		log("promo_impress", {
			type: "popup_reviews",
		});
	}

	_close() {
		if (!this._dialog) {
			return;
		}
		document.body.style.overflow = "";
		this._dialog.close();
		this._dialog = null;
	}
}
